module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="gererActivites">\r\n  <div class="activites-form"></div>\r\n  <div class="absences-form"></div>\r\n</div>';
}
return __p;
};
